import lrsAdapter from '../../../helpers/lrs_adapter'
import getAxiosInstance from '../../../helpers/get_axios_instance'
import { CupoUtils } from './cuposUtils'
import format from 'date-fns/format'

// Servicio de cupos

export class CupoService {
  static async getCupos () {
    try {
      const axios = getAxiosInstance()
      const response = await axios.get(`consulta_cupo_asignado_vigente_listado?r=` +
        `{"orden": ["fecha_de_emision"]}`)
      return lrsAdapter(response)
    } catch (error) {
      console.error(error)
      throw error
    }
  }

  static getCuposHistoricoEntreFechas (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_cupo_asignado_listado?r={"clave":{"fecha_desde": "${format(fechaD, 'yyyy-MM-dd')}", "fecha_hasta": "${format(fechaH, 'yyyy-MM-dd')}"}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static getCuposVigentesConFiltro (claveCereal) {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_cupo_asignado_filtrado_listado?r={"clave":{"clave_cereal": "${claveCereal}"}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static async getCuposVigentesDisponibles () {
    try {
      const axios = getAxiosInstance()
      const response = await axios.get(`consulta_cupo_asignado_vigente_disponibles_listado?r=` +
        `{"orden": ["fecha_de_emision"]}`)
      return lrsAdapter(response)
    } catch (error) {
      console.error(error)
      throw error
    }
  }

  static getCuposVigentesPorCereal () {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_cupo_asignado_por_cereal_tipo_fecha`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static getTotalCuposAsignadosVigentes () {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_cupos_asignados_totales_por_fecha`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static async getCuposNominados () {
    const axios = getAxiosInstance()
    try {
      const response = await axios.get(`consulta_cupo_nominado_vigente_listado`)
      return lrsAdapter(response)
    } catch (error) {
      console.error(lrsAdapter(error))
      throw error
    }
  }

  // Devuelve el listador de los cupos nominados de determinada fecha
  static async getCuposNominadosPorFecha (fecha) {
    const axios = getAxiosInstance()
    return axios.get(`/consulta_cupo_nominado?r={"clave":{"fecha": "${format(fecha, 'yyyy-MM-dd')}"}}`).then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
  }

  static async getCuposNominadosEntreFechas (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_cupo_nominado_entre_fechas?r={"clave":{"fecha_desde": "${format(fechaD, 'yyyy-MM-dd')}", "fecha_hasta": "${format(fechaH, 'yyyy-MM-dd')}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
      .catch(lrsAdapter)
  }

  // Devuelve el total de los cupos nominados de determinada fecha
  static async getTotalCuposNominados (fechaActualizada) {
    const axios = getAxiosInstance()
    return axios.get(`/consulta_total_cupos_nominados?r={"parametros":{"fecha": "${format(fechaActualizada, 'yyyy-MM-dd')}"}}`).then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
  }

  static async asignarCupos (cupoAsignado) {
    const axios = getAxiosInstance()
    const tipo = CupoUtils.parseTipoCupo(cupoAsignado.tipo).toLowerCase()
    try {
      return lrsAdapter(
        await axios.post(`cupo_${tipo}_asignado`, {
          valores: { ...cupoAsignado.cupo }
        })
      )
    } catch (error) {
      console.error(lrsAdapter(error))
      throw error
    }
  }

  static async asignarCuposCache (cupoAsignado) {
    const axios = getAxiosInstance()
    const promise = axios.post(`cupo_asignado_cache`,
      `{"valores": {"fecha_de_emision": "${cupoAsignado.cupo['fechaDeEmision']}",
      "exportador": ${cupoAsignado.cupo['exportador']}, "cereal": "${cupoAsignado.cupo['cereal']}",
      "tipo_cupo": "${cupoAsignado.tipo}", "cantidad_asignada": ${cupoAsignado.cupo['cantidadAsignada']}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static async nominarCuposCache (datosDeCupo, datosDeNotificacion, usuario) {
    const axios = getAxiosInstance()
    const promise = axios.post(`cupo_nominado_cache`,
      `{"valores": {"fecha_de_emision": "${datosDeCupo.fechaDeEmision}",
      "exportador": ${datosDeCupo.cuitExportador}, "cereal": "${datosDeCupo.claveCereal}",
      "cargador": ${datosDeCupo.cargador}, "corredor": ${datosDeCupo.corredor}, "razon_social_exportador": "${datosDeCupo.exportador}",
      "razon_social_cargador": "${datosDeCupo.razonSocialCargador}", "razon_social_corredor": "${datosDeCupo.razonSocialCorredor}",
      "cantidad": ${datosDeCupo.cantidadNominada}, "notificar_cargador": "${datosDeNotificacion.notificarCargador}",
      "notificar_corredor": "${datosDeNotificacion.notificarCorredor}", "correo_cargador": "${datosDeNotificacion.correoCargador}",
      "correo_corredor": "${datosDeNotificacion.correoCorredor}", "usuario": "${usuario}" }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static async getCuposAsignadosCache () {
    const axios = getAxiosInstance()
    const promise = axios.get(`cupo_asignado_cache_listado?r=` +
    `{"orden": ["fecha_de_emision"]}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static async getCuposNominadosCache (usuario) {
    const axios = getAxiosInstance()
    const promise = axios.get(`cupo_nominado_cache_listado?r=` +
    `{"clave": { "usuario": "${usuario}"}, "orden": ["fecha_de_emision"]}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static async getCuposNominadosCacheCupo (cupo) {
    const axios = getAxiosInstance()
    const promise = axios.get(`cupo_nominado_cache_listado_cupo?r=` +
    `{"clave": {"fecha_de_emision": "${cupo.fechaDeEmision}", "cereal": "${cupo.claveCereal}", "exportador": ${cupo.cuitExportador}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static async deleteCuposNominadosCacheIndividual (datosDeCupoCache) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`cupo_nominado_cache_individual?r=` +
    `{"clave": {"fecha_de_emision": "${datosDeCupoCache.fechaDeEmision}", "cereal": "${datosDeCupoCache.cereal}", 
    "cargador": ${datosDeCupoCache.cargador}, "corredor": ${datosDeCupoCache.corredor}, "exportador": ${datosDeCupoCache.exportador}, 
    "usuario": "${datosDeCupoCache.usuario}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static async modificarCantidadCuposNominadosCacheIndividual (datosDeCupoCache) {
    const axios = getAxiosInstance()
    const promise = axios.put(`cupo_nominado_cache_individual`,
      `{"valores": {"cantidad": ${datosDeCupoCache.cantidadNominada}}, 
    "clave": {"fecha_de_emision": "${datosDeCupoCache.fechaDeEmision}", "cereal": "${datosDeCupoCache.cereal}", 
    "cargador": ${datosDeCupoCache.cargador}, "corredor": ${datosDeCupoCache.corredor}, "exportador": ${datosDeCupoCache.exportador}, 
    "usuario": "${datosDeCupoCache.usuario}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static async deleteCuposAsignadosCacheIndividual (fechaDeEmision, cereal, tipoCupo, exportador) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`cupo_asignado_cache_individual?r=` +
    `{"clave": {"fecha_de_emision": "${fechaDeEmision}", "cereal": "${cereal}", "tipo_cupo": "${tipoCupo}", "exportador": ${exportador}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static async deleteCuposNominadosCache (usuario) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`cupo_nominado_cache?r=` +
    `{"clave": { "usuario": "${usuario}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static async deleteCuposAsignadosCache () {
    const axios = getAxiosInstance()
    const promise = axios.delete(`cupo_asignado_cache`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static async deleteCuposAsignadosCacheXExportador (exportador) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`cupo_asignado_cache_x_exportador?r=` +
    `{"clave": { "exportador": ${exportador}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static async nominarCupos (cupoNominado) {
    const axios = getAxiosInstance()
    try {
      return lrsAdapter(
        await axios.post(`v_cupo_nominado`, {
          valores: { ...cupoNominado }
        })
      )
    } catch (error) {
      console.error(lrsAdapter(error))
      throw error
    }
  }

  static async modificarBloqueoCupos (clave, tipo, habilitado) {
    const axios = getAxiosInstance()
    const parsedTipo = CupoUtils.parseTipoCupo(tipo).toLowerCase()
    try {
      return lrsAdapter(
        await axios.put(`cupo_${parsedTipo}_bloqueable`, {
          valores: { habilitado },
          clave: { ...clave }
        })
      )
    } catch (error) {
      console.error(lrsAdapter(error))
      throw error
    }
  }

  static async modificarCupos (clave, tipo, newCupo) {
    const axios = getAxiosInstance()
    const parsedTipo = CupoUtils.parseTipoCupo(tipo).toLowerCase()
    try {
      return lrsAdapter(
        await axios.put(`cupo_${parsedTipo}_asignado`, {
          valores: { ...newCupo },
          clave: { ...clave }
        })
      )
    } catch (error) {
      console.error(lrsAdapter(error))
      throw error
    }
  }

  static async modificarCupoNominado (cupo, clave) {
    const axios = getAxiosInstance()
    try {
      return lrsAdapter(
        await axios.put('v_cupo_nominado', {
          valores: { ...cupo },
          clave: { ...clave }
        })
      )
    } catch (error) {
      console.error(lrsAdapter(error))
      throw error
    }
  }

  static async getCupo (clave) {
    const axios = getAxiosInstance()
    try {
      return lrsAdapter(
        await axios.get(`cupo_asignado_lote?r={"clave":${JSON.stringify(clave)}}`)
      )
    } catch (error) {
      console.error(lrsAdapter(error))
      throw error
    }
  }

  static async bajaCupos (clave, tipo) {
    const axios = getAxiosInstance()
    try {
      return lrsAdapter(
        await axios.delete(
          `cupo_${tipo}_asignado?r={"clave":${JSON.stringify(clave)}}`
        )
      )
    } catch (error) {
      console.error(lrsAdapter(error))
      throw error
    }
  }

  static async bajaCupoNominado (clave) {
    const axios = getAxiosInstance()
    try {
      return lrsAdapter(
        await axios.delete(
          `v_cupo_nominado?r={"clave":${JSON.stringify(clave)}}`
        )
      )
    } catch (error) {
      console.error(lrsAdapter(error))
      throw error
    }
  }

  static async getCupoNominadoXCodigo (codigoCupo) {
    const axios = getAxiosInstance()
    const promise = axios.get(`cupo_nominado_x_codigo?r=` +
    `{"clave": {"codigo_cupo": "${codigoCupo}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data[0])
  }

  static async borrarCupoDeStopQ (cupo) {
    const axios = getAxiosInstance()
    const promise = axios.get(`borrar_cupo_de_stopq?r=` +
      `{"parametros": {"id_cupo": ${cupo.idCupo}, "exportador": ${cupo.exportador},
      "codigo_cupo": "${cupo.codigoCupo}", "fecha_cupo": "${cupo.fechaCupo}", "cereal": ${cupo.grano}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data[0])
  }

  static async liberarCupoNominado (codigoCupo) {
    const axios = getAxiosInstance()
    const promise = axios.get(`liberar_cupo_nominado?r=` +
      `{"parametros": {"codigo_cupo": "${codigoCupo}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data[0])
  }
}
